<template>
  <div>
    <Search
      :allowCollapse="false"
      :url="url"
      :title="$lang.cultural_social"
      :allowFields="$lang.social_person_fields"
      primaryKey="id"
      config="person_SocialPerson"
      addModalSize="lg"
      removeModalSize="xl"
      :visibleSearch="false"
      :visibleSettings="false"
      :visibleExport="false"
      :visibleFilters="false"
      :visibleViewCount="false"
      :allowEdit="false"
      :toggleable="true"
      :visibleAccordion="true"
      ref="searchSocialPerson"
      :dynamicButtons="dynamicButtons"
      :parentPermissions="permissions"
      :showAlert="true"
      colorAlert="success"
      :titleAlert="$lang.Institutions"
      :relation_type_id="$config.relation_type.socialRevolutionary"
      resource="person_social"
      @getPermisson="updatePermissions"
      :visibleAdd="isAdmin(permissions, ['admin'])"
    >
      <template slot="alerts">
        <div
          v-if="checkCustomKey('isRegisterPersonRelation', false)"
          class="font-weight-bold border-0 bg-white mb-3"
        >
          <span v-text="$lang.textPersonEditRow1" class="text-danger" />
          <i class="fa fa-users fa-lg text-info" />
          <span v-text="$lang.textPersonEditRow2" class="text-danger" />
        </div>
      </template>
      <template slot="addModal" slot-scope="search">
        <AddSocialPerson
          :code="code"
          :parentPermissions="permissions"
          @personRelation="personRelation"
          @cancel="search.close"
          @getData="getData"
        />
      </template>
    </Search>
    <b-modal
      no-close-on-backdrop
      hide-footer
      :title="$lang.search.columns_setting"
      variant="primary"
      hide-header
      content-class="border-primary"
      size="xl"
      v-model="modalNewColumn"
      :ok-title="$lang.submitButton"
    >
      <EditSocialPerson
        v-if="mode === 'edit'"
        :itemId="itemId"
        :code="code"
        :parentPermissions="permissions"
        @cancel="closeModal"
        @personRelation="personRelation"
        @getData="getData"
      />
      <SearchPersonRelation
        v-if="mode === 'searchPersonRelation'"
        :code="code"
        :relation_type_id="$config.relation_type.socialRevolutionary"
        :resource_id="resource_id"
        resource="person_social_experience"
        :title="'افراد مرتبط با سوابق فرهنگی و اجتماعی'"
        @cancel="closeModal"
        @getData="getData"
      />
    </b-modal>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddSocialPerson from "./addSocialPerson";
import EditSocialPerson from "./editSocialPerson";
import SearchPersonRelation from "./../personRelation/searchPersonRelation";
import { pathOr } from "ramda";
import {
  isAdmin,
  generateApiUrl,
  checkCustomKey,
  checkActivePersonRelation,
} from "@/shared/utils";

export default {
  name: "search-social-person",
  components: {
    Search,
    AddSocialPerson,
    EditSocialPerson,
    SearchPersonRelation,
  },
  props: {
    code: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      permissions: [],
      itemId: null,
      modalNewColumn: false,
      mode: null,
      resource_id: null,
      buttons: [
        {
          id: 0,
          name: "edit",
          click: this.changeEdit,
        },
        {
          id: "1",
          name: "view",
          click: this.changePersonSocial,
        },
        {
          id: "3",
          name: "person_relation",
          click: this.personRelation,
        },
        {
          id: "3",
          name: "delete",
        },
      ],
    };
  },
  computed: {
    url() {
      return generateApiUrl(["profile", "person_social"], [this.code]);
    },
  },
  methods: {
    pathOr,
    isAdmin,
    generateApiUrl,
    checkCustomKey,
    checkActivePersonRelation,
    closeModal() {
      this.modalNewColumn = false;
    },
    getData() {
      this.$refs.searchSocialPerson.getItems();
    },
    changeEdit(item) {
      this.itemId = item && item.id;
      this.mode = "edit";
      this.modalNewColumn = true;
    },
    personRelation(item) {
      if (checkActivePersonRelation(item)) {
        this.modalNewColumn = true;
        this.itemId = null;
        this.mode = "searchPersonRelation";
        this.resource_id = pathOr(null, ["id"], item);
      } else {
        this.closeModal();
        this.getData();
        return;
      }
    },
    updatePermissions(data) {
      this.permissions = [...data];
      this.$emit("getPermissions", data);
    },
    dynamicButtons(item) {
      return this.buttons.map((button) => {
        if (button.name === "person_relation") {
          return {
            ...button,
            showIcon: this.checkActivePersonRelation(item),
          };
        }
        return button;
      });
    },
  },
};
</script>
